var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProgressSaving01 = function SvgProgressSaving01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "progress_saving-01_svg2__a",
    x1: 29.75,
    x2: 165.62,
    y1: 170.24,
    y2: 34.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M140.21 15.79c-1.35-.35-2.89-.4-8.67-.4H40.52c-5.87 0-9.81 0-12.85.25-2.95.24-4.36.67-5.28 1.14a12.84 12.84 0 0 0-5.6 5.6c-.47.93-.9 2.34-1.14 5.28-.25 3.03-.25 6.98-.25 12.85v118.96c0 5.87 0 9.81.25 12.85.24 2.94.67 4.35 1.14 5.28 1.23 2.41 3.19 4.37 5.6 5.6.93.47 2.34.9 5.28 1.14 3.04.25 6.98.25 12.85.25h.51V153c0-5.48 0-10.05.31-13.79.32-3.9 1.01-7.55 2.77-11.01 2.7-5.3 7.01-9.62 12.32-12.33 3.46-1.76 7.12-2.45 11.02-2.77 3.74-.3 8.31-.3 13.79-.3h37.55c5.48 0 10.05 0 13.79.3 3.9.32 7.55 1.01 11.01 2.77 5.3 2.7 9.62 7.02 12.33 12.33 1.76 3.46 2.45 7.12 2.77 11.02.3 3.73.3 8.29.3 13.76v31.62h.51c5.87 0 9.81 0 12.84-.25 2.94-.24 4.35-.67 5.28-1.14 2.42-1.23 4.38-3.19 5.61-5.6.47-.93.9-2.34 1.14-5.28.25-3.03.25-6.98.25-12.85V71.56c0-4.99-.05-6.33-.31-7.52-.28-1.23-.73-2.41-1.34-3.5-.6-1.06-1.46-2.08-4.8-5.8l-27.95-31.06c-3.86-4.29-4.94-5.4-6.1-6.18-1.2-.79-2.52-1.38-3.91-1.74v.02Zm11.11 184.2h8.47c5.48 0 10.05 0 13.79-.31 3.9-.32 7.55-1.01 11.01-2.77 5.3-2.7 9.62-7.02 12.33-12.33 1.76-3.46 2.45-7.12 2.77-11.02.3-3.73.3-8.29.3-13.76V70.89c0-4.01 0-7.16-.68-10.22-.6-2.69-1.59-5.28-2.95-7.69-1.54-2.73-3.64-5.06-6.31-8.03-.15-.17-.3-.33-.46-.51l-27.95-31.06c-.17-.19-.35-.39-.52-.57-3.09-3.44-5.51-6.13-8.51-8.12a28.3 28.3 0 0 0-8.6-3.83c-3.45-.87-7.07-.87-11.67-.87H40.21c-5.48 0-10.05 0-13.79.31-3.9.32-7.56 1.01-11.02 2.77A28.18 28.18 0 0 0 3.08 15.4C1.32 18.86.63 22.52.31 26.41 0 30.15 0 34.72 0 40.2v119.59c0 5.48 0 10.05.31 13.79.32 3.9 1.01 7.55 2.77 11.01 2.7 5.3 7.02 9.62 12.32 12.33 3.46 1.76 7.12 2.45 11.02 2.77 3.74.31 8.31.31 13.79.31h111.11Zm-7.73-15.38v-31.28c0-5.87 0-9.81-.25-12.85-.24-2.95-.67-4.35-1.14-5.28a12.8 12.8 0 0 0-5.61-5.6c-.93-.47-2.34-.9-5.28-1.14-3.03-.25-6.97-.25-12.84-.25H81.55c-5.87 0-9.81 0-12.85.25-2.95.24-4.36.67-5.28 1.14a12.84 12.84 0 0 0-5.6 5.6c-.47.93-.9 2.34-1.14 5.28-.25 3.03-.25 6.98-.25 12.85v31.28h87.18zM61.55 48.72c0-4.25 3.44-7.69 7.69-7.69h61.54c4.25 0 7.69 3.44 7.69 7.69s-3.44 7.69-7.69 7.69H69.24c-4.25 0-7.69-3.44-7.69-7.69",
    style: {
      fill: "url(#progress_saving-01_svg2__a)",
      fillRule: "evenodd"
    }
  }));
};
export default SvgProgressSaving01;